module.exports = __webpack_public_path__ + "img/cannon-tower.ad05c5fc.webp";